import type { BackendRouteDefinition } from '../types';

export const sharedRoutes = {
  getApiVersion: {
    transport: 'api',
    method: 'GET',
    path: '/version',
  },
  createFirmFromLead: {
    transport: 'api',
    method: 'POST',
    path: '/public/signup/firms',
    body: (requestData: { leadId: string }) => ({ leadId: requestData.leadId }),
  },
} as const satisfies Record<string, BackendRouteDefinition>;
